// This installation does not link to the documentation of the open source project, so there are no help links.
// Set the URLs here to show a "Learn more" link in the settings pages.
const FEATURE_HELP_URLS = {};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
